import { isSuperAdminUser } from "./superAdmin";

/** Permission requirements for hash-based admin views. */

export const ADMIN_VIEW_ACCESS = {
  moderation: {
    permissions: ["map.layers.view"],
    mode: "any",
  },
  "data-health": {
    permissions: ["real_estate.sources.view", "system.audit.view"],
    mode: "any",
  },
  "property-import": {
    permissions: ["real_estate.listings.edit"],
    mode: "any",
  },
  "real-estate-sources": {
    permissions: ["real_estate.sources.view", "real_estate.sources.manage"],
    mode: "any",
  },
  "real-estate-source-controls": {
    permissions: ["real_estate.sources.manage"],
    mode: "any",
  },
  "real-estate-source-quality": {
    permissions: ["real_estate.sources.view"],
    mode: "any",
  },
  "real-estate-image-health": {
    permissions: ["real_estate.listings.view"],
    mode: "any",
  },
  "real-estate-image-cache": {
    permissions: ["real_estate.sources.manage"],
    mode: "any",
  },
  "real-estate-media-quality": {
    permissions: ["real_estate.sources.view"],
    mode: "any",
  },
  "geocode-queue": {
    permissions: ["real_estate.listings.edit"],
    mode: "any",
  },
  "real-estate-location-quality": {
    permissions: ["real_estate.sources.view"],
    mode: "any",
  },
  "duplicate-review": {
    permissions: ["real_estate.duplicates.review"],
    mode: "any",
  },
  "canonical-listings": {
    permissions: ["real_estate.listings.view"],
    mode: "any",
  },
  "real-estate-review": {
    permissions: ["real_estate.duplicates.review", "real_estate.listings.edit"],
    mode: "any",
  },
  "weather-intelligence": {
    permissions: ["weather.layers.view"],
    mode: "any",
  },
  "weather-source-controls": {
    permissions: ["weather.layers.view"],
    mode: "any",
  },
  "finance-source-controls": {
    permissions: ["real_estate.sources.manage"],
    mode: "any",
  },
  users: {
    permissions: ["users.manage"],
    mode: "any",
  },
  roles: {
    permissions: ["roles.manage"],
    mode: "any",
  },
  "audit-log": {
    permissions: ["system.audit.view"],
    mode: "any",
  },
  "privacy-operations": {
    permissions: [
      "privacy.requests.view",
      "privacy.requests.manage",
      "system.audit.view",
    ],
    mode: "any",
  },
  "ingestion-logs": {
    permissions: ["real_estate.sources.view"],
    mode: "any",
  },
  partners: {
    permissions: ["partners.view"],
    mode: "any",
  },
  "lead-broker-config": {
    permissions: ["users.manage"],
    mode: "any",
  },
  "geo-boundaries": {
    permissions: ["map.layers.view", "map.layers.manage"],
    mode: "any",
  },
  "food-source-discovery": {
    permissions: ["real_estate.sources.view", "real_estate.sources.manage"],
    mode: "any",
  },
  "vehicle-source-review": {
    permissions: ["real_estate.sources.view", "real_estate.sources.manage"],
    mode: "any",
  },
  "vehicle-lookups": {
    permissions: ["real_estate.sources.view", "real_estate.sources.manage"],
    mode: "any",
  },
  "vehicle-price-events": {
    permissions: ["real_estate.sources.view", "real_estate.sources.manage"],
    mode: "any",
  },
  "vehicle-lifecycle-events": {
    permissions: ["real_estate.sources.view", "real_estate.sources.manage"],
    mode: "any",
  },
  "vehicle-normalization-issues": {
    permissions: ["real_estate.sources.view", "real_estate.sources.manage"],
    mode: "any",
  },
  "vehicle-duplicate-review": {
    permissions: ["real_estate.sources.view", "real_estate.sources.manage"],
    mode: "any",
  },
  "canonical-vehicles": {
    permissions: ["real_estate.sources.view", "real_estate.sources.manage"],
    mode: "any",
  },
  "vehicle-model-copy": {
    permissions: ["real_estate.sources.view", "real_estate.sources.manage"],
    mode: "any",
  },
  "vehicle-model-copy-quality": {
    permissions: ["real_estate.sources.view", "real_estate.sources.manage"],
    mode: "any",
  },
  "vehicle-data-quality": {
    permissions: ["real_estate.sources.view", "real_estate.sources.manage"],
    mode: "any",
  },
  "vehicle-fair-value": {
    permissions: ["real_estate.sources.view", "real_estate.sources.manage"],
    mode: "any",
  },
  "vehicle-best-value": {
    permissions: ["real_estate.sources.view", "real_estate.sources.manage"],
    mode: "any",
  },
  "vehicle-new-price-baselines": {
    permissions: ["real_estate.sources.view", "real_estate.sources.manage"],
    mode: "any",
  },
  "vehicle-depreciation": {
    permissions: ["real_estate.sources.view", "real_estate.sources.manage"],
    mode: "any",
  },
  "vehicle-predictive-pricing": {
    permissions: ["real_estate.sources.view", "real_estate.sources.manage"],
    mode: "any",
  },
  "vehicle-pricing-models": {
    permissions: ["real_estate.sources.view", "real_estate.sources.manage"],
    mode: "any",
  },
  "vehicle-deal-finder": {
    permissions: ["real_estate.sources.view", "real_estate.sources.manage"],
    mode: "any",
  },
  "vehicle-alerts": {
    permissions: ["real_estate.sources.view", "real_estate.sources.manage"],
    mode: "any",
  },
  "vehicle-market-analytics": {
    permissions: ["real_estate.sources.view", "real_estate.sources.manage"],
    mode: "any",
  },
  "automotive-dealer-coverage": {
    permissions: ["real_estate.sources.view", "real_estate.sources.manage"],
    mode: "any",
  },
  "automotive-dealers": {
    permissions: ["real_estate.sources.view", "real_estate.sources.manage"],
    mode: "any",
  },
  "automotive-dealer-review": {
    permissions: ["real_estate.sources.view", "real_estate.sources.manage"],
    mode: "any",
  },
  "automotive-dealer-detail": {
    permissions: ["real_estate.sources.view", "real_estate.sources.manage"],
    mode: "any",
  },
  "automotive-dealer-governance": {
    permissions: ["real_estate.sources.view", "real_estate.sources.manage"],
    mode: "any",
  },
  "automotive-dealer-partnerships": {
    permissions: ["real_estate.sources.view", "real_estate.sources.manage"],
    mode: "any",
  },
  "vehicle-source-health": {
    permissions: ["real_estate.sources.view", "real_estate.sources.manage"],
    mode: "any",
  },
  "food-normalization": {
    permissions: ["real_estate.sources.view", "real_estate.sources.manage"],
    mode: "any",
  },
  "food-basket-calculation": {
    permissions: ["real_estate.sources.view", "real_estate.sources.manage"],
    mode: "any",
  },
  "food-wholesale-ingestion": {
    permissions: ["real_estate.sources.view", "real_estate.sources.manage"],
    mode: "any",
  },
  "food-retail-ingestion": {
    permissions: ["real_estate.sources.view", "real_estate.sources.manage"],
    mode: "any",
  },
  "food-ara-normalization-review": {
    permissions: ["real_estate.sources.view", "real_estate.sources.manage"],
    mode: "any",
  },
  "food-supply-ingestion": {
    permissions: ["real_estate.sources.view", "real_estate.sources.manage"],
    mode: "any",
  },
  "food-input-ingestion": {
    permissions: ["real_estate.sources.view", "real_estate.sources.manage"],
    mode: "any",
  },
  "food-access-map": {
    permissions: ["real_estate.sources.view", "real_estate.sources.manage"],
    mode: "any",
  },
  "food-access-operations": {
    permissions: ["real_estate.sources.view", "real_estate.sources.manage"],
    mode: "any",
  },
  "food-store-review-queue": {
    permissions: ["real_estate.sources.view", "real_estate.sources.manage"],
    mode: "any",
  },
  "food-chain-branch-locator-strategy": {
    permissions: ["real_estate.sources.view", "real_estate.sources.manage"],
    mode: "any",
  },
  "food-chain-branch-imports": {
    permissions: ["real_estate.sources.view", "real_estate.sources.manage"],
    mode: "any",
  },
  "food-chain-locator-audits": {
    permissions: ["real_estate.sources.view", "real_estate.sources.manage"],
    mode: "any",
  },
  "food-store-reconciliation": {
    permissions: ["real_estate.sources.view", "real_estate.sources.manage"],
    mode: "any",
  },
  "food-recommendations": {
    permissions: ["real_estate.sources.view", "real_estate.sources.manage"],
    mode: "any",
  },
  "transport-qa": {
    permissions: ["real_estate.sources.view", "system.audit.view"],
    mode: "any",
  },
  "transport-operations": {
    permissions: ["real_estate.sources.view", "system.audit.view"],
    mode: "any",
  },
  "transport-service-alerts": {
    permissions: ["real_estate.sources.view", "system.audit.view"],
    mode: "any",
  },
  "transport-live-operations": {
    permissions: ["real_estate.sources.view", "system.audit.view"],
    mode: "any",
  },
  "transport-mobility-reports": {
    permissions: ["map.layers.view"],
    mode: "any",
  },
  "culture-submissions": {
    permissions: ["map.layers.view"],
    mode: "any",
  },
  "culture-taxonomy": {
    permissions: ["map.layers.view"],
    mode: "any",
  },
  "culture-moderation": {
    permissions: ["map.layers.view"],
    mode: "any",
  },
  "culture-venues": {
    permissions: ["map.layers.view"],
    mode: "any",
  },
  "culture-dashboard": {
    permissions: ["real_estate.sources.view", "system.audit.view"],
    mode: "any",
  },
  "transport-road-incidents": {
    permissions: ["real_estate.sources.view", "real_estate.sources.manage"],
    mode: "any",
  },
  "client-organizations": {
    permissions: ["client_admin.view", "client_views.manage", "users.manage"],
    mode: "any",
  },
  "client-users": {
    permissions: ["client_admin.view", "client_views.manage", "users.manage"],
    mode: "any",
  },
  "client-publishing": {
    permissions: [
      "client_admin.manage_publishing",
      "client_admin.view",
      "client_views.manage",
      "users.manage",
    ],
    mode: "any",
  },
};

export const WORKFLOW_PERMISSIONS = {
  realEstateSourceControls: ["real_estate.sources.manage"],
  financeSourceControls: ["real_estate.sources.manage"],
  vehicleSources: ["real_estate.sources.view", "real_estate.sources.manage"],
  vehicleSourceReview: ["real_estate.sources.view", "real_estate.sources.manage"],
  vehicleLookups: ["real_estate.sources.view", "real_estate.sources.manage"],
  vehicleIngestionRuns: ["real_estate.sources.view", "real_estate.sources.manage"],
  vehiclePriceEvents: ["real_estate.sources.view", "real_estate.sources.manage"],
  vehicleLifecycleEvents: ["real_estate.sources.view", "real_estate.sources.manage"],
  vehicleNormalizationIssues: ["real_estate.sources.view", "real_estate.sources.manage"],
  vehicleDuplicateReview: ["real_estate.sources.view", "real_estate.sources.manage"],
  canonicalVehicles: ["real_estate.sources.view", "real_estate.sources.manage"],
  vehicleModelCopy: ["real_estate.sources.view", "real_estate.sources.manage"],
  vehicleSourceHealth: ["real_estate.sources.view", "real_estate.sources.manage"],
  vehicleDataQuality: ["real_estate.sources.view", "real_estate.sources.manage"],
  dataHealth: ["real_estate.sources.view", "system.audit.view"],
  dataOverview: ["data_flows.flows.view"],
  dataFlowsConnections: ["data_flows.connections.view"],
  dataFlowsDatasets: ["data_flows.datasets.view"],
  dataFlowsList: ["data_flows.flows.view"],
  dataRunsList: ["data_flows.runs.view"],
  dataFlowsNew: ["data_flows.flows.manage"],
  dataImageMedia: ["data_flows.flows.view"],
  dataImageMediaCasaMapa: ["data_flows.flows.view"],
  dataImageMediaActivity: ["data_flows.flows.view"],
  dataImageMediaCustomers: ["data_flows.flows.view"],
  dataImageMediaBilling: ["data_flows.flows.view"],
  dataImageMediaApi: ["data_flows.flows.view"],
  moderation: ["map.layers.view"],
  propertyImport: ["real_estate.listings.edit"],
  realEstateSources: ["real_estate.sources.view", "real_estate.sources.manage"],
  geocodeQueue: ["real_estate.listings.edit"],
  locationQuality: ["real_estate.sources.view"],
  duplicateReview: ["real_estate.duplicates.review"],
  availabilityReview: ["real_estate.listings.edit", "real_estate.duplicates.review"],
  canonicalListings: ["real_estate.listings.view"],
  brokerSources: ["real_estate.sources.view"],
  weatherIntelligence: ["weather.layers.view"],
  weatherSourceControls: ["weather.layers.view"],
  weatherSourceHealth: ["weather.layers.view"],
  weatherRadarCalibration: ["weather.layers.manage"],
  users: ["users.manage"],
  roles: ["roles.manage"],
  auditLog: ["system.audit.view"],
  privacyOperations: [
    "privacy.requests.view",
    "privacy.requests.manage",
    "system.audit.view",
  ],
  mediaQualityDashboard: ["real_estate.sources.view"],
  ingestionLogs: ["real_estate.sources.view"],
  partners: ["partners.view"],
  leadBrokerConfig: ["users.manage"],
  geoBoundaries: ["map.layers.view", "map.layers.manage"],
  foodSourceDiscovery: ["real_estate.sources.view", "real_estate.sources.manage"],
  foodNormalization: ["real_estate.sources.view", "real_estate.sources.manage"],
  foodBasketCalculation: ["real_estate.sources.view", "real_estate.sources.manage"],
  foodWholesaleIngestion: ["real_estate.sources.view", "real_estate.sources.manage"],
  foodRetailIngestion: ["real_estate.sources.view", "real_estate.sources.manage"],
  foodSupplyIngestion: ["real_estate.sources.view", "real_estate.sources.manage"],
  foodInputIngestion: ["real_estate.sources.view", "real_estate.sources.manage"],
  foodAccessMap: ["real_estate.sources.view", "real_estate.sources.manage"],
  foodAccessOperations: ["real_estate.sources.manage"],
  foodChainBranchLocatorStrategy: [
    "real_estate.sources.view",
    "real_estate.sources.manage",
  ],
  foodChainBranchImports: ["real_estate.sources.view", "real_estate.sources.manage"],
  foodStoreReconciliation: ["real_estate.sources.view", "real_estate.sources.manage"],
  foodRecommendations: ["real_estate.sources.view", "real_estate.sources.manage"],
  foodStoreReviewQueue: ["real_estate.sources.view", "real_estate.sources.manage"],
  foodAraNormalizationReview: ["real_estate.sources.view", "real_estate.sources.manage"],
  foodChainLocatorAudits: ["real_estate.sources.view", "real_estate.sources.manage"],
  analyticsSourceControls: ["real_estate.sources.view", "real_estate.sources.manage"],
  weatherConsole: ["weather.layers.view"],
  automapaAdmin: ["real_estate.sources.view", "users.manage"],
  clientViewsAdmin: ["client_views.manage", "client_admin.view", "users.manage"],
  platformIam: ["client_views.manage", "client_admin.view", "users.manage"],
  cultureDashboard: ["map.layers.view"],
  cultureSubmissions: ["map.layers.view"],
  cultureModeration: ["map.layers.view"],
  cultureTaxonomy: ["map.layers.view"],
  cultureVenues: ["map.layers.view"],
  transportQa: ["map.layers.view"],
  transportOperations: ["map.layers.view"],
  transportServiceAlerts: ["map.layers.view"],
  transportLiveOperations: ["map.layers.view"],
  transportMobilityReports: ["map.layers.view"],
  transportPublicPages: ["map.layers.view"],
  transportRoadIncidents: ["map.layers.view"],
  transportReports: ["map.layers.view"],
  automotiveDealerCoverage: ["real_estate.sources.view"],
  automotiveDealers: ["real_estate.sources.view"],
  automotiveDealerReview: ["real_estate.sources.view"],
  automotiveDealerGovernance: ["real_estate.sources.view"],
  automotiveDealerPartnerships: ["real_estate.sources.view"],
  vehicleFairValue: ["real_estate.sources.view"],
  vehicleBestValue: ["real_estate.sources.view"],
  vehicleNewPriceBaselines: ["real_estate.sources.view"],
  vehicleDepreciation: ["real_estate.sources.view"],
  vehiclePredictivePricing: ["real_estate.sources.view"],
  vehiclePricingModels: ["real_estate.sources.view"],
  vehicleDealFinder: ["real_estate.sources.view"],
  vehicleAlerts: ["real_estate.sources.view"],
  vehicleMarketAnalytics: ["real_estate.sources.view"],
  clientOrganizations: ["client_admin.view", "client_views.manage", "users.manage"],
  clientUsers: ["client_admin.view", "client_views.manage", "users.manage"],
  clientPublishing: [
    "client_admin.manage_publishing",
    "client_admin.view",
    "client_views.manage",
    "users.manage",
  ],
};

export const ADMIN_HASH_BY_VIEW = {
  moderation: "#/admin/community-reports",
  "data-health": "#/admin/data-health",
  "property-import": "#/admin/property-import",
  "real-estate-sources": "#/admin/real-estate-sources",
  "real-estate-source-controls": "#/admin/real-estate-source-controls",
  "real-estate-source-quality": "#/admin/real-estate-source-quality",
  "real-estate-image-health": "#/admin/real-estate-image-health",
  "real-estate-image-cache": "#/admin/real-estate-image-cache",
  "real-estate-media-quality": "#/admin/real-estate-media-quality",
  "geocode-queue": "#/admin/geocode-queue",
  "real-estate-location-quality": "#/admin/real-estate-location-quality",
  "duplicate-review": "#/admin/duplicate-review",
  "canonical-listings": "#/admin/canonical-listings",
  "real-estate-review": "#/admin/real-estate-availability-review",
  "weather-intelligence": "#/weather-intelligence",
  "weather-source-controls": "#/admin/weather-source-controls",
  "finance-source-controls": "#/admin/finance-source-controls",
  users: "#/admin/users",
  roles: "#/admin/roles",
  "audit-log": "#/admin/audit-log",
  "privacy-operations": "#/admin/privacy-operations",
  "ingestion-logs": "#/admin/ingestion-logs",
  partners: "#/admin/partners",
  "lead-broker-config": "#/admin/lead-broker-config",
  "geo-boundaries": "#/admin/geo-boundaries",
  "food-source-discovery": "#/admin/food-source-discovery",
  "vehicle-source-review": "#/admin/vehicle-source-review",
  "vehicle-lookups": "#/admin/vehicle-lookups",
  "vehicle-price-events": "#/admin/vehicle-price-events",
  "vehicle-lifecycle-events": "#/admin/vehicle-lifecycle-events",
  "vehicle-normalization-issues": "#/admin/vehicle-normalization-issues",
  "vehicle-duplicate-review": "#/admin/vehicle-duplicate-review",
  "canonical-vehicles": "#/admin/canonical-vehicles",
  "vehicle-model-copy": "#/admin/vehicle-model-copy",
  "vehicle-model-copy-quality": "#/admin/vehicle-model-copy-quality",
  "vehicle-source-health": "#/admin/vehicle-source-health",
  "vehicle-data-quality": "#/admin/vehicle-data-quality",
  "vehicle-fair-value": "#/admin/vehicle-fair-value",
  "vehicle-best-value": "#/admin/vehicle-best-value",
  "vehicle-new-price-baselines": "#/admin/vehicle-new-price-baselines",
  "vehicle-depreciation": "#/admin/vehicle-depreciation",
  "vehicle-predictive-pricing": "#/admin/vehicle-predictive-pricing",
  "vehicle-pricing-models": "#/admin/vehicle-pricing-models",
  "vehicle-deal-finder": "#/admin/vehicle-deal-finder",
  "vehicle-alerts": "#/admin/vehicle-alerts",
  "vehicle-market-analytics": "#/admin/vehicle-market-analytics",
  "automotive-dealer-coverage": "#/admin/automotive-dealer-coverage",
  "automotive-dealers": "#/admin/automotive-dealers",
  "automotive-dealer-review": "#/admin/automotive-dealer-review",
  "automotive-dealer-governance": "#/admin/automotive-dealer-governance",
  "automotive-dealer-partnerships": "#/admin/automotive-dealer-partnerships",
  "food-normalization": "#/admin/food-normalization",
  "food-basket-calculation": "#/admin/food-basket-calculation",
  "food-wholesale-ingestion": "#/admin/food-wholesale-ingestion",
  "food-retail-ingestion": "#/admin/food-retail-ingestion",
  "food-ara-normalization-review": "#/admin/food-ara-normalization-review",
  "food-supply-ingestion": "#/admin/food-supply-ingestion",
  "food-input-ingestion": "#/admin/food-input-ingestion",
  "food-access-map": "#/admin/food-access-map",
  "food-access-operations": "#/admin/food-access-operations",
  "food-store-review-queue": "#/admin/food-store-review-queue",
  "food-chain-branch-locator-strategy": "#/admin/food-chain-branch-locator-strategy",
  "food-chain-branch-imports": "#/admin/food-chain-branch-imports",
  "food-chain-locator-audits": "#/admin/food-chain-locator-audits",
  "food-store-reconciliation": "#/admin/food-store-reconciliation",
  "food-recommendations": "#/admin/food-recommendations",
  "culture-submissions": "#/admin/culture-submissions",
  "culture-taxonomy": "#/admin/culture-taxonomy",
  "culture-moderation": "#/admin/culture-moderation",
  "culture-venues": "#/admin/culture-venues",
  "culture-dashboard": "#/admin/culture-dashboard",
  "client-organizations": "#/admin/client-organizations",
  "client-users": "#/admin/client-users",
  "client-publishing": "#/admin/client-publishing/pending",
};

export const DEFAULT_POST_LOGIN_HASH = "#/admin/real-estate-source-controls";

export function canAccessAdminView(user, adminView) {
  if (!adminView) {
    return true;
  }

  if (!user) {
    return false;
  }

  if (isSuperAdminUser(user)) {
    return true;
  }

  const rule = ADMIN_VIEW_ACCESS[adminView];
  if (!rule) {
    return true;
  }

  const permissions = user.permissions || [];

  if (rule.mode === "all") {
    return rule.permissions.every((code) => permissions.includes(code));
  }

  return rule.permissions.some((code) => permissions.includes(code));
}

export function canAccessWorkflow(user, workflowKey) {
  const required = WORKFLOW_PERMISSIONS[workflowKey];
  if (!required?.length) {
    return true;
  }

  if (!user) {
    return false;
  }

  if (isSuperAdminUser(user)) {
    return true;
  }

  const permissions = user.permissions || [];
  return required.some((code) => permissions.includes(code));
}
